import { Collection } from 'modules/core/lib/mobx-rest'

import EmployeePicture from 'modules/employees/store/models/EmployeePicture'

export class EmployeePictures extends Collection<EmployeePicture> {
  get cacheKey(): string {
    return 'employeePictures'
  }

  get indexes() {
    return ['employee_id']
  }

  model() {
    return EmployeePicture
  }
}
